import { useDispatch } from 'react-redux';
import { ACCESS_TOKEN, USER_DETAILS, USER_ID } from '../common/constants';
import { removeauthInfo, resetAuth } from '../common/features/auth/AuthActions';
import { useNavigate } from 'react-router';
import {
  removeCartItemOrderType,
  resetCart,
  startEmptyCart,
  clearDeliveryInstruction,
} from '../common/features/cart/cartActions';
import { clearGetDeliveryCharge, resetDelivery } from '../common/features/delivery/DeliveryActions';
import {
  removeDeliveryAddress,
  resetRestaurant,
} from '../common/features/restaurant/restaurantAction';
import { removeCardDetails, resetPayment } from '../common/features/payment/PaymentActions';
import { resetCheckIn } from '../common/features/checkIn/checkInActions';
import { resetOffer } from '../common/features/offers/offerActions';
import { useSelector } from 'react-redux';
import { storeSelectedIngredientChecklist, storeToggleStatus } from '../common/features/restaurant/restaurantAction';
import { deleteCookie } from '../helper/cookieHelper';

const useAuth = (params?: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rawData = localStorage.getItem('restaurant');
  const slugFromLocalStorage = rawData ? JSON.parse(rawData) : {};
  const isExploretabActive = useSelector((state: any) => state.restaurant.isExploretabActive)

  const handleLogout = (routeTo: string = 'menu') => {
    deleteCookie(USER_ID);
    deleteCookie(USER_DETAILS);
    deleteCookie(ACCESS_TOKEN);
    dispatch(removeauthInfo());
    dispatch(resetAuth());
    dispatch(resetCheckIn());
    dispatch(resetDelivery());
    dispatch(resetOffer());
    dispatch(resetPayment());
    dispatch(resetRestaurant());
    dispatch(resetCart());
    dispatch(clearDeliveryInstruction());
    dispatch(clearGetDeliveryCharge());
    dispatch(removeDeliveryAddress());
    dispatch(removeCardDetails());
    dispatch(
      storeToggleStatus({
        onlyAvailable: false,
        nonVegetarian: false,
        vegetarian: false,
      })
    );
    dispatch(storeSelectedIngredientChecklist([]));
    dispatch(
      startEmptyCart({
        menuType: slugFromLocalStorage?.menuType,
        restaurantSlug: slugFromLocalStorage?.location,
        clearCartItems: true,
        merchantType: '',
      })
    );
    dispatch(removeCartItemOrderType());
    if(isExploretabActive){
      navigate(
        `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}/exploremenu`
      );
    }else{
      switch (routeTo) {
      case 'menu':
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
        );
        break;
      case 'noRedirect':
        break;
      default:
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${slugFromLocalStorage?.menuType}`
        );
        break;
    }
    }
  };

  return {
    handleLogout,
  };
};

export default useAuth;
